import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';

export const StyledBundleContainer = styled.div``;

interface AddonContainerProps {
  calories: string | number;
}

export const StyledAddonContainer = styled.div<AddonContainerProps>`
  .addon-name {
    flex-basis: ${props => (props?.calories ? '60%' : 'unset')};
  }
  .diet-allergen-codes-info {
    column-gap: ${toRem(4)};
  }
`;

interface SectionItemContainerProps {
  calories: string | number;
}

export const StyledSectionItemMain = styled.div`
  row-gap: ${toRem(12)};
`;

export const StyledSectionItemContainer = styled.div<SectionItemContainerProps>`
  .section-item-container {
    flex-basis: 60%;
  }

  .diet-allergen-codes-info {
    column-gap: ${toRem(4)};
  }
  .no-wrap {
    white-space: nowrap;
  }
`;
